import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import Typography from 'gu-ui-kit/Typography'
import styles from '../nav.module.scss'

const RecommendationLink = React.forwardRef(
  ({ className, activeClassName, exact, to, children, ...rest }, ref) => {
    const { recommendation = 0 } = useSelector(
      (state) => ({
        recommendation: state.notifications?.counters?.recommendation,
      }),
      shallowEqual,
    )

    return (
      <NavLink
        activeClassName={activeClassName}
        className={className}
        exact={exact}
        innerRef={ref}
        to={to}
        {...rest}
      >
        {children}
        {recommendation !== 0 && (
          <Typography
            className={styles['nav__link-badge']}
            component={'span'}
            variant={'Body-10'}
          >
            {recommendation}
          </Typography>
        )}
      </NavLink>
    )
  },
)

RecommendationLink.displayName = 'RecommendationLink'

export default RecommendationLink

RecommendationLink.propTypes = {
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  exact: PropTypes.bool,
  to: PropTypes.string,
  children: PropTypes.node,
}
